import {TableHead, TableRow, TableCell, Checkbox, TableSortLabel, Box} from "@mui/material";
export type rowT = { id: number }

export interface HeadCell<T = rowT> {
	disablePadding?: boolean;
	id: keyof T;
	label: string;
}

export interface IProps<T = rowT> {
	headCells: HeadCell<T>[],
	selected: T[];
	currentPage: T[],
	onRequestSort: (event: React.MouseEvent<unknown>, property: keyof T) => void;
	onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
	order: EnhancedTableHeadOrder;
	pageSize: number,
	orderBy?: keyof T;
	rowCount: number;
}
export type EnhancedTableHeadOrder = "asc" | "desc";

export const EnhancedTableHead = <T extends rowT>(props: IProps<T>): JSX.Element => {
	const {onSelectAllClick, order, orderBy, currentPage, selected, rowCount, onRequestSort} = props;
	const createSortHandler =
		(property: keyof T) => (event: React.MouseEvent<unknown>) => {
			onRequestSort(event, property);
		};

	const numSelected = selected.length;
	const pageSelected = currentPage.filter(e => selected.map(x => x.id).includes(e.id));
	return (
		<TableHead>
			<TableRow>
				<TableCell padding="checkbox">
					<Checkbox
						color="primary"
						indeterminate={numSelected > 0 && (numSelected <= currentPage.length || pageSelected.length !== currentPage.length)}
						checked={rowCount > 0 && pageSelected.length === currentPage.length}
						onChange={onSelectAllClick}
						inputProps={{
							"aria-label": "select all desserts"
						}}
					/>
				</TableCell>
				{props.headCells.map((headCell) => (
					<TableCell
						key={headCell.id as any}
						padding={headCell.disablePadding ? "none" : "normal"}
						sortDirection={orderBy === headCell.id ? order : false}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : "asc"}
							onClick={createSortHandler(headCell.id)}
						>
							{headCell.label}
							{orderBy === headCell.id ? (
								<Box component="span">
									{order === "desc" ? "sorted descending" : "sorted ascending"}
								</Box>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
				<TableCell>
				</TableCell>
			</TableRow>
		</TableHead>
	);
}